<template>
  <div v-if="product.prices" class="pricesNonMember">
    <!-- TODO Wording can only view discounts as non member -->
    <!-- <div class="rrp">*RRP: {{CurrencyFormatter(product.prices.retail)}}</div> -->
    <div class="gold font-weight-bold" v-if="product.prices.savings_amounts.gold > 0">Cherrytree Gold Members save {{CurrencyFormatter(product.prices.savings_amounts.gold)}} off RRP</div>
    <div class="silver" v-if="product.prices.savings_amounts.silver > 0">Cherrytree Silver Members save {{CurrencyFormatter(product.prices.savings_amounts.silver)}} off RRP</div>
    <p class="mt-3">Only Cherrytree Members can see the prices of our items.</p>
    <router-link :to="{name:'signup', query:{redirect: $route.path}}" class="my-2 btn btn-primary d-block">Sign up Free</router-link>
  </div>
</template>

<script>
import {CurrencyFormatter} from "@/utils";

export default {
  name: "ProductPricesPublic",
  props: ["product"],
  methods: {
      CurrencyFormatter
  },
};
</script>

<style lang="scss" scoped>
.rrp{
    color:grey;
}

.silver{

}

.gold{

}


</style>
